import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton } from '@mui/material';
import type React from 'react';

import clientUtils from '@/utils/clientUtils';

interface Props {
  open: boolean;
  title?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl'; // this is not implemented
  children?: React.ReactNode;
  id?: string | null;
  onClose: () => void;
}

function VNModal({ open, title, size = 'xl', children, id = null, onClose }: Props) {
  if (!open) {
    return null;
  }

  const onTitleClick = () => {
    if (id) {
      clientUtils.copyToClipboard(id);
    }
  };

  return (
    <div className={`vn-modal ${size}`}>
      <div className="modal-body">
        <div className="modal-header">
          <DialogTitle sx={{ cursor: id ? 'pointer' : 'none' }} onClick={onTitleClick}>
            {title}
          </DialogTitle>
          <IconButton aria-label="close" onClick={onClose} className="modal-close-button">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}

export default VNModal;
